import React, { useCallback } from 'react'
import Loading from '../../components/common/Loading'
import { opdDetail } from '../../constant/path'
import { useScreen } from '../../utils/responsive-helper'
import { useRouter } from '../../utils/helper'
import { useGetEClaimHistoryById } from '../../services/e-claim/e-claim-query'
import { UserClaimDocumentList, FileType, ClaimDocumentTypes } from '../../services/e-claim/e-claim-types'
import OpdInfo from './OpdInfo'
import OpdForm from '../OPDDetail/OpdForm'
import { useMemo } from 'react'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { setOpdInfo } from '../../redux-store/opd-reducer'
import config from '../../config'
import colors from '../../constant/colors'

export type InitialValueType = {
  name: string
  amountReceipt: number
  amountClaim: number
  receiptFile: string
  optionalFileUrl: string
  relativeTypeId: string
  receiptDate: string
  claimName: string
}

const OpdHistoryDetail = () => {
  const { query } = useRouter<{ id: number }>()
  const history = useHistory()
  const dispatch = useDispatch()
  const { data: opdItem, isLoading } = useGetEClaimHistoryById({ id: query.id })
  const {
    claim,
    userClaimAmount,
    userClaimAmountApprove,
    relativeId,
    slipDate,
  } = opdItem || {}

  const receiptFile = useMemo(() => {
    if (!opdItem?.documentTypes) return ''

    return opdItem?.documentTypes?.filter(item => item.name === FileType.ReceiptFile)[0]?.files?.length > 0
      ? opdItem.documentTypes.filter(item => item.name === FileType.ReceiptFile)[0].files[0].name
      : ''
  }, [opdItem?.documentTypes])

  const optionalFileUrl = useMemo(() => {
    if (!opdItem?.documentTypes) return ''

    return opdItem?.documentTypes?.filter(item => item.name === FileType.OptionalFileUrl)[0]?.files?.length > 0
      ? opdItem.documentTypes.filter(item => item.name === FileType.OptionalFileUrl)[0].files[0].name
      : ''
  }, [opdItem?.documentTypes])

  const initialValue = useMemo(() => {
    return {
      name: claim?.name || '',
      amountReceipt: userClaimAmount,
      amountClaim: userClaimAmountApprove,
      receiptFile,
      optionalFileUrl,
      relativeTypeId: relativeId ? relativeId.toString() : '',
      receiptDate: slipDate,
      claimName: claim?.name || '',
    }
  }, [claim, userClaimAmount, userClaimAmountApprove, relativeId, slipDate, receiptFile, optionalFileUrl])

  const disable = useMemo(() => {
    if (!opdItem?.isApproved && (opdItem?.isApproved !== null)) {
      return false
    } else {
      return true
    }
  }, [opdItem?.isApproved])

  const onCreateNewOpd = useCallback(async () => {
    if (opdItem?.id === undefined) return

    dispatch(
      setOpdInfo({
        name: opdItem.claim.name || '',
        amountReceipt: opdItem.userClaimAmount,
        amountClaim: opdItem.userClaimAmountApprove,
        receiptFile,
        optionalFileUrl,
        relativeTypeId: opdItem.relativeId ? opdItem.relativeId.toString() : '',
        receiptDate: opdItem.slipDate,
        claimName: opdItem.claim.name || '',
        clinicType: opdItem.remark || '',
        receiptNo: opdItem?.receiptNo || '',
        // remark: opdItem?.remark || '',
      }),
    )

    history.push(opdDetail({
      routeParam: {
        opdId: opdItem?.claimId
      },
      queryParam: {
        isCreateNew: 'true'
      }
    }))
  }, [opdItem, history, dispatch, receiptFile, optionalFileUrl])

  if (!opdItem || isLoading) return null

  return (
    <Loading loading={isLoading}>
      <div style={{ paddingTop: '24px' }}>
        <Headbar title={claim?.name || ''} backWard={paths.opdHistory()} titleColor={colors.BLACK} />
        <OpdInfo id={query.id} opdItem={opdItem} onCreateNewOpd={onCreateNewOpd} />
        <OpdForm
          opdItem={opdItem}
          opdId={opdItem.claimId}
          // eClaimItem={initialValue}
          // initialValues={eClaimItem?.claim}
          initialValues={initialValue}
          allpayStatus={disable}
          isHistory={true}
          editable={false}
        />
      </div>
    </Loading>
  )
}

export default OpdHistoryDetail